import { Link } from "react-router-dom";
import { Seo } from "@/components/site/Seo";

export default function NotFound() {
  return (
    <section className="flex min-h-[80vh] items-center bg-[#13052A] px-5 pt-32 text-white" data-testid="not-found">
      <Seo title="Page not found" path="/404" noindex />
      <div className="mx-auto max-w-xl text-center">
        <p className="serif-accent text-8xl text-[#C4B5FD]">404</p>
        <h1 className="mt-4 text-3xl font-extrabold sm:text-4xl">This page needs a check-up.</h1>
        <p className="mt-4 text-violet-100">The page you're looking for doesn't exist or has moved.</p>
        <Link to="/" className="btn-primary mt-8" data-testid="not-found-home">Back to home</Link>
      </div>
    </section>
  );
}
